import React from 'react';
import {withTranslation} from 'react-i18next';
import CollaboratorItem from '../collaborator-item/index';
import Loader from '../../../../../../../../../../../../../../components/sprite/components/loader/index';
import {connect} from 'react-redux';
import {
	findDomainGroup, loadNewDomainGroup,
} from '../../../../../../../../../../../../../../../actions/domainGroupActions';
import UserStatuses from '../collaborator-item/components/user-statuses/index';
import Icon from '../../../../../../../../../../../../../../components/icon';
import GetBackButton from './components/getback-button';
import { APP_URL } from '../../../../../../../../../../../../../../utils';
import './index.css';

class CollaboratorsGroupDetails extends React.Component {

	componentDidMount() {

		this.props.setFindDomainGroup(this.props.id, this.props.domainGroupPageSize);

		let pollingForData = false;

		if (document.querySelector('.collaborators-list__body')) {
			document.querySelector('.collaborators-list__body').addEventListener('scroll', (e) => {
				if (Math.floor(e.target.scrollHeight - e.target.scrollTop) <= document.querySelector('.collaborators-list__body').clientHeight) {
					//console.log('This is the end!');
					if (this.props.findDomainGroup.domainGroups.length < this.props.findDomainGroup.pages.totalRecords) {
						pollingForData = true;
					}

					if (pollingForData) {
						this.props.loadNewDomainGroup(this.props.selectedCollaborator.id, this.props.domainGroupPageSize, this.props.domainGroupNextPage);

						pollingForData = false;
					}

				}
			});
		}

	}

	displayCollaboratorsGroupDetails() {
		if (this.props.findDomainGroup !== null) {
			if (this.props.findDomainGroup.domainGroups.length > 0) {
				if (this.props.enteredCollaboratorSearchValue !== '') {
					return this.props.findDomainGroup.domainGroups.map(collaborator => {
						if (collaborator.name.toLowerCase().includes(this.props.enteredCollaboratorSearchValue.toLowerCase())) {
							return (
								<div key={collaborator.id} className="d-flex align-items-center p-2">
									<div className="col-3 text-truncate"
									     title={collaborator.name}>{collaborator.name}</div>
									<div className="col-3 text-truncate"
									     title={collaborator.email}>{collaborator.email}</div>
									<div className="text-center col-3">
										<UserStatuses
											collaboratorId={collaborator.id}
											collaboratorEmail={collaborator.email}
											collaboratorType={collaborator.type}
											collaboratorStatuses={collaborator.statuses}
											selectedCollaboratorMode={this.props.mode === 'selectedGroup'}
										/>
									</div>
									<div className="col-3">
										{
											collaborator.statuses.licenseLimitReached && collaborator.statuses.unknown === false
												?
												<a href={`/api/payment/add`} target="_blank" className="btn btn-link"
												   rel="noreferrer">{this.props.t('textGCMAddLicenses')}</a>
												:
												''
										}
									</div>
								</div>
							)
						} else {
							return null
						}
					});
				} else {
					return this.props.findDomainGroup.domainGroups.map(collaborator => (
						<div key={collaborator.id} className="d-flex align-items-center p-2">
							<div className="col-3 text-truncate" title={collaborator.name}>{collaborator.name}</div>
							<div className="col-3 text-truncate" title={collaborator.email}>{collaborator.email}</div>
							<div className="text-center col-3">
								<UserStatuses
									collaboratorId={collaborator.id}
									collaboratorEmail={collaborator.email}
									collaboratorType={collaborator.type}
									collaboratorStatuses={collaborator.statuses}
									selectedCollaboratorMode={this.props.mode === 'selectedGroup'}
								/>
							</div>
							<div className="col-3">
								{
									collaborator.statuses.licenseLimitReached && collaborator.statuses.unknown === false
										?
										<a href={`/api/payment/add`} target="_blank" className="btn btn-link"
										   rel="noreferrer">{this.props.t('textGCMAddLicenses')}</a>
										:
										''
								}
							</div>
						</div>
					));
				}
			}
		} else {
			return (
				<div className="d-flex align-items-center justify-content-center p-2">
					<Icon animated={'pulse'} name="spinner"/>
				</div>
			)
		}
	}

	render() {
		return (
			<div className="collaborators-group-details">
				<div className="collaborators">
					{
						this.props.findCollaborators !== null
							?
							this.props.findCollaborators.collaborators.map((collaborator, index) => {
								if (this.props.selectedCollaborator.id === collaborator.id) {
									return (
										<CollaboratorItem
											key={this.props.selectedContactsGroup.id + collaborator.id}
											id={collaborator.id}
											groupId={collaborator.groupId}
											index={index}
											avatar={`${APP_URL}/account/avatar/${collaborator.id}`}
											name={collaborator.name}
											email={collaborator.email}
											statuses={collaborator.statuses}
											syncopt={collaborator.addToContact}
											permission={collaborator.permission}
											type={collaborator.type}
											mode={'selectedCollaboratorsGroup'}
										/>
									);
								} else {
									return null
								}
							})
							:
							<Loader/>
					}
				</div>
				<div className="collaborators-list">
					<div className="d-flex collaborators-list__head p-2">
						<div className="col-3">{this.props.t('textName')}</div>
						<div className="col-3">{this.props.t('fieldEmail')}</div>
						<div className="text-center col-3">{this.props.t('popupSharingStatus')}</div>
						<div className="col-3">{this.props.t('textAction')}</div>
					</div>
					<div className="collaborators-list__body">
						{
							this.props.isNewCollaboratorsListLoading
								?
								<div className="d-flex align-items-center collaborators-list__body__loading">
									<Loader/>
								</div>
								:
								null
						}
						{this.displayCollaboratorsGroupDetails()}
					</div>
				</div>
				<GetBackButton/>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		findDomainGroup: state.domainGroupReducer.findDomainGroup,
		enteredCollaboratorSearchValue: state.sharingDetailsReducer.enteredCollaboratorSearchValue,
		domainGroupNextPage: state.domainGroupReducer.domainGroupNextPage,
		domainGroupPageSize: state.domainGroupReducer.domainGroupPageSize,
		isNewCollaboratorsListLoading: state.domainGroupReducer.isNewCollaboratorsListLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadNewDomainGroup: (selectedCollaboratorId, pageSize, nextPage) => {
			dispatch(loadNewDomainGroup(selectedCollaboratorId, pageSize, nextPage))
		},
		setFindDomainGroup: (collaboratorId, pageSize) => {
			dispatch(findDomainGroup(collaboratorId, pageSize))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CollaboratorsGroupDetails));
